module.exports = __webpack_public_path__ + "img/PressFreedomIndex.8a1577c8.png";